import GroupDisplay from './components/GroupDisplay';

interface Address {
  address1: string;
  address2: string | null;
  city: string;
}

interface Country {
  abbr: string;
  name: string;
}

interface State {
  abbr: string;
  name: string;
}

interface Logo {
  id: number;
  original: string;
  thumbnail: string;
}

interface Facility {
  address: Address;
  country: Country;
  city: string;
  postalCode: string;
  state: State;
  id: number;
  isDefault: boolean;
  logo: Logo;
  name: string;
  phone: string;
  phoneExt: string | number | null;
  url: string;
}

interface Group {
  businessName: string;
  facilities: Facility[];
}
interface CurrentGroup {
  id: number;
  group: Group;
}

interface CurrentGroupCardProps {
  currentGroup: CurrentGroup;
}

export default function CurrentGroupCard({
  currentGroup,
}: CurrentGroupCardProps) {
  const { group } = currentGroup;
  const { businessName, facilities } = group;

  const defaultFacility = facilities.find(
    (facility: Facility) => facility.isDefault === true,
  );

  const addressData = defaultFacility?.address;

  let displayAddress = '';
  if (addressData) {
    const { address1, address2, state, city, postalCode } = addressData;
    if (address1) {
      displayAddress = address1;

      if (address2) {
        displayAddress = displayAddress + ', ' + address2;
      }
    }

    if (city) {
      displayAddress = displayAddress ? displayAddress + ' ' + city : city;
    }

    if (state) {
      displayAddress = displayAddress
        ? displayAddress + ', ' + state?.abbr
        : state?.abbr;
    }

    if (postalCode) {
      displayAddress = displayAddress
        ? displayAddress + ' ' + postalCode
        : postalCode;
    }
  }

  const logoURL = defaultFacility?.logo?.original;

  return (
    <GroupDisplay
      logoURL={logoURL}
      businessName={businessName}
      displayAddress={displayAddress}
    />
  );
}
